import { breakpoints, colors } from 'style'
import styled from 'styled-components'

export const StoryContainer = styled.div`
  margin-bottom: 25px;

  .stories-wrapper {
    height: 100%;
    overflow-y: auto;
  }

  .accordion {
    .accordion-toggler {
      color: ${colors.dark7};
      background: ${colors.white};
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 50px;

      .accordion-button {
        background-color: ${colors.white};

        .toggler-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;

          h3 {
            font-size: 28px;
          }
          .icon-option:hover {em
            opacity: 0.7;
          }
          .header-icon {
            height: 36px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 20px;
          }
          .hide-checkbox {
            margin-left: 20px;
            color: white;
            display: flex !important;
          }
        }
      }
    }
  }
  .modal-images {
    .ant-modal {
      .carousel {
        .carousel-indicators {
          bottom: 60px;
        }
        .carousel-inner {
          min-height: 300px;
          .carousel-item {
            text-align: center;
            img {
              max-width: 100%;
              max-height: 300px;
              margin: 0 auto;
            }
            .carousel-caption {
              position: unset;
              color: ${colors.dark8};
              min-height: 40px;
              margin-top: 20px;
              padding-top: 0;
              padding-bottom: 0;
            }
          }
        }
      }
    }
  }
  .modal-answer {
    .ant-modal {
      width: 100% !important;
      .answer-content-wrapper {
        display: flex;
        flex-direction: column;
        /* align-items: stretch; */
        justify-content: space-between;
        .answer-info-sm {
          display: none;
        }
        .answer-info-md {
          display: flex;
          align-items: stretch;
          .answer-content {
            flex: 1;
            // margin-right: 42px;
            .answer-content-title {
              font-size: 15px;
            }
            .quill {
              .ql-container {
                max-height: 600px;
                overflow: auto;
                .ql-editor {
                  min-height: 300px;
                }
              }
            }
            .btns-content-wrapper {
              margin-left: auto;
              margin-top: 15px;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              .btn {
                height: 25px;
                border-radius: 5px;
                color: white;
                font-size: 15px;
                padding: 0 16px;
                margin-left: 25px;
                line-height: 21px;
              }
            }
          }
          .answer-images {
            width: 555px;
            .answer-images-title {
              font-size: 15px;
            }
            .image-selector {
              border: solid 1px #bfbfbf;
              padding: 10px;
              justify-content: center;
              .ant-upload-drag {
                max-height: 111px;
                display: flex;
                align-items: center;
                padding: 16px;
                .ant-upload-drag-container {
                  display: flex;
                  align-items: center;
                  .ant-upload-drag-icon {
                    border: solid 1px #bfbfbf;
                    margin-bottom: 0;
                    margin-right: 10px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    background: antiquewhite;
                    &.ver {
                      width: 70px;
                      height: 100px;
                    }
                    &.hor {
                      width: 100px;
                      height: 70px;
                    }
                  }
                }
              }
            }
            .pending-images {
              margin-top: 20px;
              h4 {
                font-size: 18px;
              }
              .pending-list {
                border: 1px solid #bfbfbf;
                min-height: 90px;
                padding: 10px;
                .pending-file-item {
                  display: flex;
                  align-items: center;
                  margin: 5px 0;
                  padding: 2px 0;
                  cursor: grab;
                  border: solid 1px transparent;
                  img {
                    border: solid 1px ${colors.gray};
                  }
                  &.row-dragging,
                  &:hover {
                    background-color: white;
                    border: solid 1px ${colors.greenDarkest};
                  }
                }
              }
              .btn-upload-wrapper {
                display: flex;
                justify-content: flex-end;
                margin-top: 10px;
                .btn-upload {
                  height: 25px;
                  border-radius: 5px;
                  color: white;
                  font-size: 15px;
                  background-color: #0b4141;
                  padding: 0 50px;
                  line-height: 21px;
                }
              }
            }
            .current-images {
              margin-top: 20px;
              h4 {
                font-size: 18px;
              }
              .current-list {
                border: 1px solid #bfbfbf;
                min-height: 90px;
                padding: 10px;
                max-height: 300px;
                overflow: auto;
                .current-img {
                  margin: 10px 0;
                  .icon-trash {
                    margin-right: 20px;
                  }
                  .img-wrapper {
                    min-width: 100px;
                    text-align: center;
                    img {
                      /* margin: 0 20px; */
                      max-height: 45px;
                      max-width: 70px;
                      width: auto;
                    }
                  }
                  h5 {
                    font-size: 15px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .modal-roles {
    padding-top: 16px;
    .role-section {
      // margin-bottom: 24px;
      .header {
        // border-bottom: 1px solid ${colors.border};
        border-bottom: 1px solid #f2f2f2;
        line-height: 1.6;
      }
      .users {
        // margin-left: 8px;
        display: flex;
        flex-direction: row;
      }
      .roles {
        display: flex;
        flex-direction: column;
        // margin-left: 8px;
        max-height: 400px;
        overflow: scroll;
        .user-role {
          height: 48px;
          display: flex;
          border-bottom: 1px solid #f2f2f2;
          justify-content: space-between;
          align-items: center;
          .user-name {
            margin-left: 2px;
          }
          .ant-radio-group {
            padding: 8px 16px;
            .ant-space {
              width: 100%;
              .ant-space-item {
                .ant-radio-wrapper {
                  border: 1px solid ${colors.blueDark};
                  border-radius: 16px;
                  margin-right: 0;
                  padding: 0 12px;
                  padding-bottom: 4px;
                  align-items: center;
                  width: 100%;
                  &.ant-radio-wrapper-checked {
                    background: ${colors.blueDark4};
                  }
                  .ant-radio-checked .ant-radio-inner {
                    border-color: ${colors.blueDark};
                    &::after {
                      background-color: ${colors.blueDark};
                    }
                  }
                }
              }
            }
          }
        }
      }

      .roles::-webkit-scrollbar {
        // display: none;
      }
    }
    .narration {
      margin: 16px;
    }
    .actions {
      padding: 8px;
      display: flex;
      justify-content: flex-end;
      .btn {
        // width: 110px;
        margin-left: 16px;
      }
    }
  }
  @media (max-width: ${breakpoints.sm}px) {
    .d-ml-20 {
      margin: 0 0.5rem;
    }

    .modal-answer {
      .ant-modal {
        top: calc(1.5em + 0.75rem);
        .answer-content-wrapper {
          .answer-info-sm {
            display: block;
            .answer-content {
              flex: 1;
              margin-right: 0px;
              margin-top: 20px;
              .answer-content-title {
                font-size: 15px;
              }
              .quill {
                .ql-container {
                  max-height: 600px;
                  overflow: auto;
                  .ql-editor {
                    min-height: 300px;
                  }
                }
              }
              .btns-content-wrapper {
                margin-left: auto;
                margin-top: 15px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                .btn {
                  height: 25px;
                  border-radius: 5px;
                  color: white;
                  font-size: 15px;
                  padding: 0 16px;
                  margin-left: 25px;
                  line-height: 21px;
                }
              }
            }
            .answer-images {
              width: 100%;
              margin-top: 20px;
              .answer-images-title {
                font-size: 15px;
              }
              .image-selector {
                display: flex;
                flex-direction: column;
                border: solid 1px #bfbfbf;
                padding: 10px;
                justify-content: center;
                .ant-upload-drag {
                  max-height: 111px;
                  display: flex;
                  align-items: center;
                  padding: 16px;
                  .ant-upload-drag-container {
                    display: flex;
                    align-items: center;
                    .ant-upload-drag-icon {
                      border: solid 1px #bfbfbf;
                      margin-bottom: 0;
                      margin-right: 10px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      flex-direction: column;
                      background: antiquewhite;
                      &.ver {
                        width: 70px;
                        height: 100px;
                      }
                      &.hor {
                        width: 100px;
                        height: 70px;
                      }
                    }
                  }
                }
              }
              .pending-images {
                margin-top: 20px;
                h4 {
                  font-size: 18px;
                }
                .pending-list {
                  border: 1px solid #bfbfbf;
                  min-height: 90px;
                  padding: 10px;
                  .pending-file-item {
                    display: flex;
                    align-items: center;
                    margin: 5px 0;
                    padding: 2px 0;
                    cursor: grab;
                    border: solid 1px transparent;
                    img {
                      border: solid 1px ${colors.gray};
                    }
                    &.row-dragging,
                    &:hover {
                      background-color: white;
                      border: solid 1px ${colors.greenDarkest};
                    }
                  }
                }
                .btn-upload-wrapper {
                  display: flex;
                  justify-content: flex-end;
                  margin-top: 10px;
                  .btn-upload {
                    height: 25px;
                    border-radius: 5px;
                    color: white;
                    font-size: 15px;
                    background-color: #0b4141;
                    padding: 0 50px;
                    line-height: 21px;
                  }
                }
              }
              .current-images {
                margin-top: 20px;
                h4 {
                  font-size: 18px;
                }
                .current-list {
                  border: 1px solid #bfbfbf;
                  min-height: 90px;
                  padding: 10px;
                  max-height: 300px;
                  overflow: auto;

                  .current-img {
                    margin: 10px 0;
                    .icon-trash {
                      margin-right: 20px;
                    }
                    .img-wrapper {
                      min-width: 100px;
                      text-align: center;
                      img {
                        /* margin: 0 20px; */
                        max-height: 45px;
                        max-width: 70px;
                        width: auto;
                      }
                    }
                    h5 {
                      font-size: 15px;
                    }
                  }
                }
              }
            }
          }
          .answer-info-md {
            display: none;
          }
        }
      }
    }
  }

  .ant-upload-drag-icon {
    svg {
      font-size: 64px !important;
    }
  }

  @media (max-width: 413px), (max-height: 845px) {
  }

  @media (min-width: 901px) {
    .accordion-story {
      padding: 0 32px !important;
    }

    .modal-custom-body.editor {
      min-height: 550px;
      max-height: 550px;
      overflow-y: scroll;
    }

    .modal-custom-body.picture {
      min-height: 400px;
    }
  }

  @media (max-width: 900px) {
    .modal-custom-body.editor {
      min-height: 450px;
      max-height: 450px;
      overflow-y: scroll;
    }

    .modal-custom-body.picture {
      min-height: 300px;
    }
  }

  .modal-custom-body.editor::-webkit-scrollbar,
  .modal-custom-body.picture::-webkit-scrollbar {
    // display: none;
  }

  // Here modal style...
  .modal-roles-wrapper,
  .modal-images,
  .modal-answer,
  .modal-story {
    .ant-modal-content {
      .answer-images {
        .actions {
          padding: 8px 0 !important;

          .green {
            background-color: #4e9e69 !important;
            border-color: #4e9e69 !important;
            color: white !important;
            min-width: 110px;
          }
        }
      }

      .ant-modal-close {
        color: white !important;
        margin-top: -3.5px;
      }

      .ant-modal-header {
        background-color: #4c4c4c;

        .ant-modal-title {
          color: white !important;
        }
      }

      .ant-modal-body {
        background-color: #f4f3f3;
      }

      .modal-custom-body {
        background-color: white;
        border-radius: 15px;

        h4 {
          text-align: center !important;
        }

        .answer-images h4,
        .answer-content h4 {
          text-align: left !important;
        }
      }

      .p20 {
        padding: 20px !important;
      }

      .mb-20 {
        margin-bottom: 20px !important;
      }

      .mt-20 {
        margin-top: 20px !important;
      }

      .ant-upload.ant-upload-drag {
        border: none;
        background: white;

        .ant-upload {
          padding: 0;
        }
      }

      .modal-custom-footer {
        padding: 24px 0 0 0 !important;

        .actions {
          padding: 8px 0 !important;

          .green {
            background-color: #4e9e69 !important;
            border-color: #4e9e69 !important;
            color: white !important;
          }

          .gray {
            background-color: #4c4c4c !important;
            border-color: #4c4c4c !important;
            color: white !important;
          }

          .blue {
            background-color: #0d89cf !important;
            border-color: #0d89cf !important;
            color: white !important;
          }
        }
      }

      .pending-images-body {
        .pending-list {
          // border: 1px solid #f2f2f2;
          min-height: 80px;
          // padding: 10px !important;

          .pending-file-item {
            border-top: 3px solid #f2f2f2;
            padding: 10px;
          }
        }

        .current-list {
          // border: 1px solid rgb(191, 191, 191);
          // min-height: 80px;
          // padding: 10px !important;

          svg {
            width: 32px;
          }
        }

        .current-img {
          border-top: 3px solid #f2f2f2;
          padding: 10px;

          svg {
            margin: 0 !important;
          }

          .img-wrapper {
            margin: 0 20px;
          }

          .actions {
            margin: 0 5px;
            button {
              margin-left: 10px;
            }
          }
        }
      }
    }
  }

  .modal-story {
    .ant-modal-body {
      background: white !important;
    }
  }

  .story-preview {
    max-height: 75vh;
    overflow-y: scroll;
  }

  .modal-story {
    h4 {
      text-align: center !important;
      font-family: 'Minion Pro Medium Italic' !important;
      font-size: 32px;
      line-height: 1.5;
      font-style: italic;
      font-weight: bold;
    }

    .story-by {
      h4 {
        text-align: left !important;
        font-size: 20px;
        font-style: italic;
        font-family: 'Minion Pro Italic' !important;
        font-weight: normal !important;
      }
    }

    p {
      font-size: 18px;
      font-family: 'Minion Pro Regular' !important;
      font-style: italic;
    }

    .answer-content {
      p {
        font-size: 18px;
        font-family: 'Minion Pro Regular' !important;
        line-height: 24px;
        font-style: normal !important;
        text-align: justify;
      }

      p:first-child::first-letter {
        font-size: 300%;
        margin-right: 2px;
      }

      p:not(:first-child) {
        text-indent: 3rem;
      }
    }
  }

  .choose-picture {
    margin-top: 10px;
  }

  @media (max-width: ${breakpoints.sm}px) {
    .modal-story {
      .ant-modal {
        width: 100% !important;

        .ant-modal-body {
          padding: 12px;
        }
      }
    }

    .modal-answer {
      .modal-custom-body {
        background-color: white !important;
      }
    }
  }

  @media (min-width: 1440px) {
    .choose-picture {
      margin-left: 27%;
      position: absolute;
    }
  }
  @media (min-width: 901px) {
    .modal-story {
      .ant-modal {
        width: 768px !important;
      }
    }
  }

  .modal-answer {
    .card-header {
      background: white;
      border: none;
      padding: 0;
    }
    .progressbar-tab {
      .tab-story {
        font-size: 16px;
        float: left;
        padding: 0.75rem 1.25rem;
        border-top: 5px solid white;
        border-right: 2.5px solid white;
        border-left: 5px solid white;
        cursor: pointer;
      }

      .tab-picture {
        font-size: 16px;
        float: left;
        padding: 0.75rem 1.25rem;
        border-top: 5px solid white;
        border-right: 5px solid white;
        border-left: 2.5px solid white;
        cursor: pointer;
      }

      .active {
        background-color: #f2f2f2;
      }
    }
  }

  @media (max-width: 900px) {
    .mobile-pending-images-body-border {
      border-top: 10px solid #f4f3f3;
      margin-top: 20px;
    }

    .p20402020 {
      padding: 20px 25px 20px 20px;
    }

    .p20204520 {
      padding: 20px 20px 45px 20px;
    }

    .m15 {
      margin: 15px;
    }
  }

  .collapse {
    background: white;
  }

  @media (min-width: 901px) {
    .p20402020 {
      padding: 20px 40px 20px 20px;
    }

    .p20204520 {
      padding: 20px 20px 40px 20px;
    }

    .d-ml-20 {
      margin-left: 20px;
    }
  }

  .hr-text {
    line-height: 1em;
    position: relative;
    outline: 0;
    border: 0;
    color: black;
    text-align: center;
    height: 1.5em;
  }
  .hr-text:before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 3.5px;
  }
  .hr-text:after {
    content: attr(data-content);
    position: relative;
    display: inline-block;
    color: black;
    padding: 0 0.5em;
    line-height: 1.5em;
    background-color: white;
    font-weight: 400;
  }

  .sent-line:before {
    background: ${colors.greenDark};
  }

  .sent-line:after {
    color: ${colors.greenDark};
  }

  .cutoff-line:before {
    background: ${colors.red};
  }

  .hr-text.cutoff-line:after {
    color: ${colors.red};
  }

  .pending-line:before {
    background: ${colors.blueDark};
  }

  .pending-line:after {
    color: ${colors.blueDark};
  }
`

export const FilterContainer = styled.div`
  transition: all 0.5s ease-in-out;
  background-color: #dddddd;
  width: 100%;
  margin-top: 10px;
  display: flex;
  align-items: center;
  padding: 8px;
  .mobile-filter-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    .ant-space-item {
      width: 100%;
    }
    .actions {
      display: flex;
      justify-content: space-between;
    }
    .ant-select {
      width: 100%;
    }
    .ant-picker {
      width: 100%;
    }
  }
`

export const QuestionItemContainer = styled.div`
  width: 100%;
  .desktop {
    display: flex;
    width: 100%;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    h6 {
      margin-bottom: 0;
      font-size: 15px;
      &.question-date {
        width: 80px;
        min-width: 80px;
      }
    }
    .question-icon {
      width: 35px;
      min-width: 35px;
      display: flex;
      justify-content: center;
      svg:hover {
        opacity: 0.7;
      }
    }
    .question-content {
      margin-left: 8px;
      /* text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden; */
    }
    .add-story-wrapper {
      display: flex;
      .add-story {
        font-size: 18px;
      }
    }
    .move-story-wrapper {
      display: flex;
      .add-story {
        font-size: 18px;
      }
    }
  }
  .mobile {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    min-height: 70px;
    .top {
      display: flex;
      justify-content: flex-start;
      width: 100%;
      margin-bottom: 8px;
      .question-icon {
        width: 35px;
        min-width: 35px;
        display: flex;
        justify-content: center;
        svg:hover {
          opacity: 0.7;
        }
      }
      .add-story-wrapper {
        display: flex;
        .add-story {
          font-size: 18px;
        }
      }
      .move-story-wrapper {
        display: flex;
        .add-story {
          font-size: 18px;
        }
      }
      .question-date {
        width: 80px;
        min-width: 80px;
      }
      .ant-tag {
        margin-right: 4px;
        padding: 0 4px;
        font-size: 10px;
        line-height: 16px;
        height: 20px;
        border-radius: 2px;
      }
    }
    h6 {
      margin-bottom: 0;
      font-size: 15px;
    }

    .bottom {
      width: 100%;
      padding-right: 24px;
      .question-content {
        /* text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden; */
      }
    }
  }
  @media (max-width: ${breakpoints.sm}px) {
    .desktop {
      display: none;
    }
  }
  @media (min-width: ${breakpoints.sm}px) {
    .mobile {
      display: none;
    }
  }
  @media (max-width: 413px), (max-height: 845px) {
  }

  .question-gray {
    color: #4c4c4c !important;
  }
`

export const AnswersContainer = styled.div`
  padding-left: 164px;
  .answer-content {
    margin-left: 23px;
    padding: 10px 50px;
    border-top: 1px solid #3d3dd8;
    p {
      font-size: 15px;
    }
  }
  @media (max-width: ${breakpoints.sm}px) {
    padding-left: 8px;
    .answer-content {
      margin-left: 0;
      padding: 10px 0px;
    }
  }
  @media (max-width: 413px), (max-height: 845px) {
  }

  .accordion-item-hide {
    display: none;
  }
`

export const AnswerItemContainer = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  padding-right: 1rem;
  .answer-icon {
    width: 35px;
    min-width: 35px;
    display: flex;
    justify-content: center;
    svg:hover {
      opacity: 0.7;
    }
  }
  h6 {
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0.4px;
    margin-bottom: 0;
  }
  .move-answer-wrapper {
    display: flex;
    margin-
  }
  @media (max-width: ${breakpoints.sm}px) {
  }
  @media (max-width: 413px), (max-height: 845px) {
  }
`
